import src from "IMAGE";
export default { src, width: 240, height: 240, blurWidth: 0, blurHeight: 0};
